
export function joinThings<L, R, K, X>(
  left: L[],
  leftKeySelector: (item: L) => K,
  right: R[],
  rightKeySelector: (item: R) => K,
  resultSelector: (left: L, right: R) => X): X[] {
  let leftGroup = (left ?? []).reduce((m, x) => m.set(leftKeySelector(x), x), new Map<K, L>());
  let rightGroup = (right ?? []).reduce((m, x) => m.set(rightKeySelector(x), x), new Map<K, R>());

  let resultMap = new Map<K, X>();

  for (let [k, l] of leftGroup) {
    let r = rightGroup.get(k);
    resultMap.set(k, resultSelector(l, r));
  }

  for (let [k, r] of rightGroup) {
    if (resultMap.has(k))
      continue;

    let l = leftGroup.get(k);
    resultMap.set(k, resultSelector(l, r));
  }

  return Array.from(resultMap.values());
}
